import { useEffect, useState, useRef } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuthStore } from "../store/auth";
import { ROUTES } from "@/config/routes";

/**
 * 인증 처리 페이지
 * 외부에서 JWT 토큰을 받아 인증 처리를 수행합니다.
 */
export default function Auth() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { me, isAuthenticated, user } = useAuthStore();
  const [localLoading, setLocalLoading] = useState(true);
  
  // 토큰 처리를 위한 참조 변수
  const tokenProcessed = useRef(false);
  
  // 인증 로직 실행
  useEffect(() => {
    console.log('Auth 페이지 useEffect 실행, tokenProcessed:', tokenProcessed.current, 'isAuthenticated:', isAuthenticated, 'user:', user);
    
    // 이미 토큰을 처리했다면 처리하지 않음
    if (tokenProcessed.current) return;
    // console.log('Auth 페이지 렌더링, tokenProcessed:', tokenProcessed, 'isAuthenticated:', isAuthenticated, 'user:', user);
    const handleAuth = async () => {
      console.log('Auth 처리 시작');
      try {
        // 이미 로그인된 상태인지 확인
        if (isAuthenticated && user) {
          console.log('[Auth] 이미 로그인되어 있음, 대시보드로 이동');
          navigate(ROUTES.DASHBOARD.EMPLOYEE.LIST);
          return;
        }
        
        // URL 파라미터에서 토큰 추출 (jwt 파라미터 사용)
        const authToken = searchParams.get("jwt");
        
        if (authToken) {
          console.log('[Auth] 토큰 발견, 인증 시도');
          tokenProcessed.current = true; // 토큰 처리 플래그 설정
          
          const success = await me(authToken);
          if (success) {
            // 인증 성공 시 대시보드로 이동
            console.log('[Auth] 인증 성공, 대시보드로 이동');
            navigate(ROUTES.DASHBOARD.EMPLOYEE.LIST);
          } else {
            // 인증 실패 시 로그인 페이지로 이동
            console.log('[Auth] 인증 실패, 로그인 페이지로 이동');
            navigate(ROUTES.SIGNIN);
          }
        } else {
          // 토큰이 없는 경우 로그인 페이지로 이동
          console.log('[Auth] 토큰 없음, 로그인 페이지로 이동');
          navigate(ROUTES.SIGNIN);
        }
      } catch (error) {
        console.error('[Auth] 인증 처리 오류:', error);
        navigate(ROUTES.SIGNIN);
      } finally {
        setLocalLoading(false);
      }
    };
    console.log('Auth handleAuth 호출 전');
    handleAuth();
  }, [isAuthenticated, user, navigate, searchParams]);

  // 로딩 상태에서는 로딩 화면 표시
  if (localLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-xl font-semibold mb-2">인증 확인 중...</h2>
          <p className="text-gray-500">잠시만 기다려 주세요.</p>
        </div>
      </div>
    );
  }
  
  // 리다이렉트는 useEffect에서 처리됨
  return null;
}
